var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchievementsP(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1356_380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0697 27.6667H19.0697C25.7363 27.6667 28.403 25 28.403 18.3333V10.3333C28.403 3.66667 25.7363 1 19.0697 1H11.0697C4.40299 1 1.73633 3.66667 1.73633 10.3333V18.3333C1.73633 25 4.40299 27.6667 11.0697 27.6667Z",
    stroke: "#8B659C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6383 8.6178C16.0396 6.77519 13.4328 6.77518 12.8341 8.6178L12.2136 10.5277H10.2055C8.26805 10.5277 7.46249 13.0069 9.02992 14.1457L10.6545 15.326L10.0339 17.2359C9.43527 19.0785 11.5442 20.6107 13.1116 19.4719L14.7362 18.2916L16.3608 19.4719C17.9283 20.6107 20.0372 19.0785 19.4385 17.2359L18.818 15.326L20.4426 14.1457C22.01 13.0069 21.2044 10.5277 19.267 10.5277H17.2589L16.6383 8.6178Z",
    stroke: "#8B659C",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1356_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementsP);
export default __webpack_public_path__ + "static/media/achievements-p.3a4a55674aa4630772560b4eff958c76.svg";
export { ForwardRef as ReactComponent };